import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';

const CareCard = ({ kind, onClose }) => {
  if (!kind) return null;

  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center bg-black/75 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="booth-care-title"
    >
      <div className="w-full max-w-xl rounded-[1.75rem] border border-white/15 bg-[#111415]
        p-5 shadow-2xl sm:p-7"
      >
        <p className="text-sm font-black uppercase tracking-[0.18em] text-cyan">Right now</p>
        <h2 id="booth-care-title" className="mt-2 font-heading text-3xl font-black">
          You don't have to carry it alone
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-white/75">
          If you're going through it right now, talk to someone. Call or text 988, any time, free.
        </p>
        {kind === 'harmed' && (
          <p className="mt-3 text-lg leading-relaxed text-white/75">
            If someone is hurting you, call or text the Childhelp line at 1-800-422-4453.
          </p>
        )}
        <div className="mt-6 grid gap-2 sm:grid-cols-3">
          <a
            href="tel:988"
            className="flex min-h-12 items-center justify-center gap-2 rounded-full bg-cyan
              px-4 text-base font-black text-black"
          >
            <Phone className="h-5 w-5" /> Call 988
          </a>
          <a
            href="sms:988"
            className="flex min-h-12 items-center justify-center gap-2 rounded-full border
              border-cyan/50 px-4 text-base font-black text-cyan"
          >
            <MessageCircle className="h-5 w-5" /> Text 988
          </a>
          <button
            type="button"
            onClick={onClose}
            className="min-h-12 rounded-full border border-white/15 px-4 text-base font-black
              hover:bg-white/[0.06]"
          >
            Keep writing
          </button>
        </div>
      </div>
    </div>
  );
};

export default CareCard;
